import { render } from "./Lembaga.vue?vue&type=template&id=48986843"
import script from "./Lembaga.vue?vue&type=script&lang=js"
export * from "./Lembaga.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__